import React from 'react';
import { Star, ExternalLink, MessageSquare } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';

const GoogleReviews = () => {
  const googleReviewsUrl = 'https://share.google/aqXegzdcNW6l9REsj';
  const leaveReviewUrl = 'https://g.page/r/CZdiiSEdTu5wEBM/review';

  const handleViewReviews = () => {
    // Track GTM event
    if (window.dataLayer) {
      window.dataLayer.push({
        'event': 'google_reviews_click',
        'button_type': 'view_all'
      });
    }
    window.open(googleReviewsUrl, '_blank');
  };

  const handleLeaveReview = () => {
    // Track GTM event
    if (window.dataLayer) {
      window.dataLayer.push({
        'event': 'google_reviews_click',
        'button_type': 'leave_review'
      });
    }
    window.open(leaveReviewUrl, '_blank');
  };

  // Avaliações REAIS do Google
  const testimonials = [
    {
      id: 1,
      name: 'Elisângela Franco',
      rating: 5,
      text: 'Excelente trabalho, prestativo e rápido no serviço. Na minha casa estava chovendo tudo dentro e com as calhas, foi resolvido o problema. Recomendo o trabalho.'
    },
    {
      id: 2,
      name: 'Wellington Lemos',
      rating: 5,
      text: 'Profissional excelente, trabalhador, honesto e cobra um preço justo, super recomendo, com certeza o melhor Calheiro da região.'
    },
    {
      id: 3,
      name: 'Luís Fernando',
      rating: 5,
      text: 'Trabalho de excelência e atendimento diferenciado, é um profissional extremamente competente, honesto e cuidadoso.'
    },
    {
      id: 4,
      name: 'Pedro Gabriel Maia',
      rating: 5,
      text: 'Trabalho rápido e com qualidade. O melhor da região.'
    },
    {
      id: 5,
      name: 'Ronaldo Santos',
      rating: 5,
      text: 'Trabalho de qualidade, totalmente responsável. Eu recomendo perfeitamente.'
    },
    {
      id: 6,
      name: 'Marcelle Louise',
      rating: 5,
      text: 'Excelente profissional. Especialista no que faz, sem contar a simpatia e capacidade de ouvir as necessidades. Recomendo'
    }
  ];

  const renderStars = (rating) => {
    return (
      <div className="flex space-x-1">
        {[...Array(5)].map((_, index) => (
          <Star
            key={index}
            className={`w-5 h-5 ${
              index < rating
                ? 'fill-yellow-400 text-yellow-400'
                : 'fill-gray-300 text-gray-300'
            }`}
          />
        ))}
      </div>
    );
  };

  return (
    <section className="py-20 bg-gradient-to-b from-white via-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <div className="flex justify-center items-center space-x-2 mb-4">
              {renderStars(5)}
              <span className="text-2xl font-bold text-nabson-navy ml-2">5.0</span>
            </div>
            <h2 className="text-4xl font-bold text-nabson-navy mb-4">
              Avaliações Reais no Google
            </h2>
            <p className="text-lg text-gray-600 mb-2">
              Boituva e Região
            </p>
            <p className="text-xl text-nabson-cyan font-semibold max-w-2xl mx-auto">
              Clientes satisfeitos com nosso acabamento e pontualidade
            </p>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row justify-center gap-4 mb-12">
            <Button
              onClick={handleViewReviews}
              className="bg-nabson-cyan hover:bg-nabson-cyan-dark text-white font-bold px-8 py-6 text-lg rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg"
            >
              <ExternalLink className="w-5 h-5 mr-2" />
              Ver todas as avaliações no Google
            </Button>
            <Button
              onClick={handleLeaveReview}
              className="bg-white hover:bg-gray-50 text-nabson-navy border-2 border-nabson-cyan font-bold px-8 py-6 text-lg rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg"
            >
              <MessageSquare className="w-5 h-5 mr-2" />
              Deixar uma avaliação
            </Button>
          </div>

          {/* Testimonials Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {testimonials.map((testimonial) => (
              <Card
                key={testimonial.id}
                className="border-2 border-gray-100 hover:border-nabson-cyan hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 bg-white"
              >
                <CardContent className="p-6">
                  {/* Rating */}
                  <div className="flex items-start mb-4">
                    {renderStars(testimonial.rating)}
                  </div>

                  {/* Review Text */}
                  <p className="text-gray-700 mb-4 leading-relaxed">
                    "{testimonial.text}"
                  </p>

                  {/* Author Info */}
                  <div className="border-t border-gray-200 pt-4">
                    <p className="font-bold text-nabson-navy">{testimonial.name}</p>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

          {/* Google Badge */}
          <div className="mt-12 text-center">
            <div className="inline-flex items-center space-x-3 bg-white px-6 py-4 rounded-full shadow-lg border-2 border-gray-100">
              <svg className="w-8 h-8" viewBox="0 0 48 48">
                <path fill="#4285F4" d="M45.12 24.5c0-1.56-.14-3.06-.4-4.5H24v8.51h11.84c-.51 2.75-2.06 5.08-4.39 6.64v5.52h7.11c4.16-3.83 6.56-9.47 6.56-16.17z"/>
                <path fill="#34A853" d="M24 46c5.94 0 10.92-1.97 14.56-5.33l-7.11-5.52c-1.97 1.32-4.49 2.1-7.45 2.1-5.73 0-10.58-3.87-12.31-9.07H4.34v5.7C7.96 41.07 15.4 46 24 46z"/>
                <path fill="#FBBC05" d="M11.69 28.18C11.25 26.86 11 25.45 11 24s.25-2.86.69-4.18v-5.7H4.34C2.85 17.09 2 20.45 2 24c0 3.55.85 6.91 2.34 9.88l7.35-5.7z"/>
                <path fill="#EA4335" d="M24 10.75c3.23 0 6.13 1.11 8.41 3.29l6.31-6.31C34.91 4.18 29.93 2 24 2 15.4 2 7.96 6.93 4.34 14.12l7.35 5.7c1.73-5.2 6.58-9.07 12.31-9.07z"/>
              </svg>
              <div className="text-left">
                <p className="text-sm font-semibold text-gray-700">Avaliado no</p>
                <p className="text-lg font-bold text-nabson-navy">Google</p>
              </div>
            </div>
          </div>

          {/* Call to Action */}
          <div className="mt-12 text-center bg-gradient-to-r from-nabson-cyan/10 to-nabson-navy/10 rounded-2xl p-8 border-2 border-nabson-cyan/20">
            <p className="text-lg text-gray-700 mb-4">
              <span className="font-bold text-nabson-navy">Quer fazer parte dessa história?</span>
              <br />
              Solicite seu orçamento e junte-se aos nossos clientes satisfeitos!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GoogleReviews;
